import styled from 'styled-components';

import ActionButton from 'components/action-button';
import LoadingAnimation from 'components/loading-animation';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { primitive } from 'styles/constants/primitives';

export const BrandAndIconContainer = styled.div`
  display: flex;
  padding-block: 1rem;
  padding-inline-start: 1rem;
  padding-inline-end: 3rem;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;

  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
`;

export const Container = styled.div<{ nativeStatusBarExist?: boolean }>`
  display: flex;
  padding: ${p => (p.nativeStatusBarExist ? '2.5rem 5%' : '1.5rem 5%')};
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  align-self: stretch;
  min-height: 70vh;
  margin: 0 auto;

  ${Styles.desktop} {
    width: 35.25rem;
    padding-block-start: 1.5rem;
    padding-block-end: 2rem;
    padding-inline: 0;
    gap: 1.5rem;
  }
`;

export const MembershipLogo = styled(Picture)`
  width: 100%;
  max-width: 17rem;
  margin: 0 auto;
`;

export const MembershipName = styled.p`
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;
  flex: 1 0 0;
  text-align: center;
  font-family: ${Styles.fontFamily.base};

  ${Styles.desktop} {
    font-size: 1.125rem;
  }
`;

export const Loading = styled(LoadingAnimation)`
  margin-block-start: 20rem;
`;

export const BackButton = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
`;

export const WidgetsContainer = styled.div`
  display: flex;
  padding: 1.5rem 1rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.5rem;
  align-self: stretch;
  background-color: ${primitive.$white};
  border-radius: 0.5rem;
`;

export const MembershipNameCard = styled.p`
  font-size: 1rem;
  align-self: flex-start;
  margin: 0;
  line-height: 1.25rem;
  font-family: ${Styles.fontFamily.base};

  ${Styles.desktop} {
    font-size: 1.125rem;
  }
`;

export const Widgets = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;
`;

export const Tile = styled.div<{ $bgColor?: string | null }>`
  background-color: ${props => (props.$bgColor ? props.$bgColor : primitive.bk.$mayoEggWhite)};
  display: flex;
  padding: 0.5rem;
  align-items: center;
  gap: 1rem;
  align-self: stretch;
  border-radius: 0.5rem;
`;

export const InformationCardImage = styled(Picture)`
  width: 3.75rem;
  height: 3.75rem;
`;

export const InformationCardTextsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  flex: 1 0 0;

  ${Styles.desktop} {
    gap: 0.5rem;
  }
`;

export const InformationCardTitle = styled.h2`
  color: ${primitive.bk.$bbqBrown};
  font-size: 0.875rem;
  line-height: 1rem;

  font-family: ${Styles.fontFamily.base};
  margin: 0;

  ${Styles.desktop} {
    font-size: 1rem;
    line-height: 1.125rem;
  }
`;

export const CardDescription = styled(SanityBlockRenderer)`
  color: ${primitive.bk.$bbqBrown};
  font-size: 0.75rem;
  font-family: ${Styles.fontFamily.body};
  line-height: 1rem;
  align-self: stretch;

  ${Styles.desktop} {
    font-size: 0.85rem;
  }
`;

export const LinkAccountButton = styled(ActionButton)`
  background-color: ${Styles.color.primary};
  display: flex;
  height: 3rem;
  padding: 0 0.75rem;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  &:hover {
    background-color: ${Styles.color.primaryHover};
  }

  width: 100%;
`;
